import React from 'react';
import PropTypes from 'prop-types';

export const thead = (
	<thead>
		<tr>
			<th>Item/Pack Name</th>
			<th>Start date</th>
			<th>Quantity</th>
			<th>List price</th>
			<th>Promo</th>
			<th>TA</th>
			<th>Net price</th>
			<th>Est. ship date</th>
			<th># of Hold inv. date</th>
			<th>Drop ship</th>
		</tr>
	</thead>
);

export const tbody = products =>
	<tbody>
		{products.map((p, i) =>
			<tr key={i}>
				<td>
					<strong>
						{p.name}
					</strong>
				</td>
				<td className="text-center">
					{p.start_date}
				</td>
				<td className="text-center">
					{p.quantity}
				</td>
				<td className="text-center">
					{p.list_price}
				</td>
				<td className="text-center">
					{p.promo}
				</td>
				<td className="text-center">
					{p.ta}
				</td>
				<td className="text-center">
					{p.net_price}
				</td>
				<td className="text-center">
					{p.est_ship_date}
				</td>
				<td className="text-center">
					{p.invoice_hold_weeks}
				</td>
				<td className="text-center">
					{p.drop_ship}
				</td>
			</tr>
		)}
	</tbody>;

tbody.propTypes = {
	products: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/ui/components/ProductList/table.js